import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import CatchErrors from "../../../Utility/CatchErrors";
import TaxExemptWidget from "./TaxExemptWidget";
import PaymentTokenWidget from "./PaymentTokenWidget";
import PoNumberWidget from "./PoNumberWidget";

export default function WholesaleTools({
  shoppingCart,
  callbacks,
  userCodes = {},
  organization
}) {
  organization ||= shoppingCart.organization; // id, name, code, flavour
  if (!organization?.id)
    return null;

  return null; // NOT YET READY

  return (
    <div className="p-2 my-2 border border-gray-600">
      <div className="pb-2">
        <span className="font-bold">{organization.name}</span>
        {' '}
        {organization.code}
      </div>

      <div className="hidden grid grid-cols-2 gap-2">
        <div>
          <CatchErrors label="po-number">
            <PoNumberWidget shoppingCart={shoppingCart} callbacks={callbacks}
              userCodes={userCodes} organization={organization} />
          </CatchErrors>
        </div>
        <div>
          <CatchErrors label="tax-exempt">
            <TaxExemptWidget shoppingCart={shoppingCart} callbacks={callbacks}
              userCodes={userCodes} organization={organization} />
          </CatchErrors>
        </div>


      </div>
    </div>
);
}
